var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5L7.9125 14.5109C4.05 11.0116 1.5 8.69619 1.5 5.87125C1.5 3.55586 3.315 1.75 5.625 1.75C6.93 1.75 8.1825 2.35695 9 3.30858C9.8175 2.35695 11.07 1.75 12.375 1.75C14.685 1.75 16.5 3.55586 16.5 5.87125C16.5 8.69619 13.95 11.0116 10.0875 14.5109L9 15.5Z",
    stroke: "#303141",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.f48898d8df89050dac593d662f58b87d.svg";
export { ForwardRef as ReactComponent };